import axios from 'axios';

const toggleOverlay = (overlay, blockScroll = true) => {
  if (!overlay) {
    document.querySelector('.OverlayFilters').classList.remove('open');
    document.querySelector('.OverlayDetails').classList.remove('open');
    document.body.classList.remove('is-open');
  } else {
    overlay.classList.toggle('open');

    if (!overlay.className.includes('OverlayDetails')) {
      document.body.classList.toggle('is-open');
      document.querySelector('.OverlayDetails').classList.remove('open');
    }
  }

  if (blockScroll) {
    document.body.classList.toggle('overflow-hidden');
  }
};

// managing the display of the overlay
const initFilters = (overlay) => {
  document.addEventListener('click', (event) => {
    const { target } = event;
    // manage open Overlay
    if (target.classList.contains('js-Filter')) {
      toggleOverlay(overlay);
      return;
    }

    // manage open Overlay details
    if (target.classList.contains('js-showFeaturesDetails')) {
      event.preventDefault();
      event.stopPropagation();

      const overlayDetails = document.querySelector('.OverlayDetails');

      if (!overlayDetails.classList.contains('open')) {
        const data = document.querySelector(`#${target.dataset.id}`);
        overlayDetails.innerHTML = data.innerHTML;
      }

      toggleOverlay(overlayDetails, false);

      return;
    }

    // click outside
    if (
      !target.closest('.OverlayFilters') &&
      document.querySelector('.OverlayFilters.open')
    ) {
      toggleOverlay();
    }
  });
};

// update products
const updateProducts = async (url, overlay) => {
  try {
    const { data } = await axios.get(url);
    const parser = new DOMParser();
    const page = parser.parseFromString(data, 'text/html');
    const productList = document.querySelector('.Category-listingProducts');

    productList.replaceWith(page.querySelector('.Category-listingProducts'));

    global.history.replaceState({}, 'recherche', `${url}`);

    toggleOverlay(overlay);
  } catch (e) {
    console.error(e);
  }
};

// manage the overlay footer display
const toggleFooter = (active = true) => {
  const overlayFooter = document.querySelector('.OverlayFilters-footer');
  const ACTIVE_CLASS = 'active';
  const BUTTON_CLASS = '.OverlayFilters-footerBtn';
  const RESET_CLASS = '.OverlayFilters-footerReset';

  overlayFooter.querySelector(BUTTON_CLASS).disabled = !active;
  overlayFooter.querySelector(RESET_CLASS).disabled = !active;
  overlayFooter.classList.toggle(ACTIVE_CLASS, active);
};

const cleanUrl = (formData, type) => {
  const featuresValue = formData.getAll(type);

  formData.delete(type);
  formData.append(type, featuresValue);
};

const manageFilters = (overlay = null) => {
  const form = document.querySelector('form[data-form-filters]');
  const formData = form ? new FormData(form) : new FormData();
  const PRECOCITY = 'precocite';
  const CARACTERISTIC = 'caracteristiques';
  const MATURITY = 'maturity';
  const OUTLET = 'outlet';
  const TYPE = 'type';
  const ADVANTAGE = 'advantage';
  const CYCLE = 'cycle';
  const PROFIL = 'profil';
  const BEST_SELLER = 'best_seller';

  const hasInitialValue =
    formData.getAll(CARACTERISTIC).length > 0 ||
    formData.getAll(PRECOCITY).length > 0;

  if (hasInitialValue) {
    toggleFooter();
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    const formData = form ? new FormData(form) : new FormData();

    const mapFeatures = [
      {
        hasOne: formData.getAll(CARACTERISTIC).length > 0,
        type: CARACTERISTIC
      },
      { hasOne: formData.getAll(PRECOCITY).length > 0, type: PRECOCITY },
      { hasOne: formData.getAll(MATURITY).length > 0, type: MATURITY },
      { hasOne: formData.getAll(OUTLET).length > 0, type: OUTLET },
      { hasOne: formData.getAll(TYPE).length > 0, type: TYPE },
      { hasOne: formData.getAll(ADVANTAGE).length > 0, type: ADVANTAGE },
      { hasOne: formData.getAll(CYCLE).length > 0, type: CYCLE },
      { hasOne: formData.getAll(PROFIL).length > 0, type: PROFIL },
      { hasOne: formData.getAll(BEST_SELLER).length > 0, type: BEST_SELLER }
    ];

    let hasValues = false;

    mapFeatures.forEach((feature) => {
      if (!hasValues) {
        hasValues = feature.hasOne;
      }
      feature.hasOne && cleanUrl(formData, feature.type);
    });

    if (!hasValues) {
      formData.delete('category_id');

      updateProducts(`?view=category`, overlay);
    } else {
      toggleFooter();

      updateProducts(
        `?view=category&${new URLSearchParams(formData).toString()}`,
        overlay
      );
    }
  });

  form.addEventListener('change', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!document.querySelector('.OverlayFilters-footer.active')) {
      toggleFooter();
    }
  });

  const resetFilters = document.querySelector('.js-resetFilters');

  resetFilters.addEventListener('click', ({ currentTarget }) => {
    const filters = document.querySelectorAll('.Checkbox:checked');
    const formData = form ? new FormData(form) : new FormData();

    filters.forEach((filter) => {
      filter.checked = false;
      formData.delete(filter.name);
    });

    updateProducts(`?view=category`);
  });
};

const OverlayFilters = () => {
  const overlay = document.querySelector('.OverlayFilters');

  if (overlay) {
    initFilters(overlay);
    manageFilters(overlay);
  }
};

export default OverlayFilters;
